module.exports = new __parcel__URL__("Business Status Update Hover.cc17fbf4.svg").toString();